import React from 'react';

const IconLimits = () => {
    return <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_51519_113917)'>
            <path fillRule='evenodd' clipRule='evenodd' d='M1.66602 15V0H0.666016V6V7V16H16.666V15H1.66602ZM14.2215 6L12.566 3.75L11.0716 6H10.166V7H10.4073L8.96602 9.17H7.33602L5.71602 11.5H3.66602V13H6.49602L8.11602 10.67H9.74602L12.2956 7H13.0375L14.676 9H16.666V7.61H15.406L14.9572 7H15.166V6H14.2215ZM2.16602 7H3.16602V6H2.16602V7ZM4.16602 7H5.16602V6H4.16602V7ZM6.16602 7H7.16602V6H6.16602V7ZM8.16602 7H9.16602V6H8.16602V7ZM16.166 7H16.666V6H16.166V7Z' fill='#1F1F1F' />
        </g>
        <defs>
            <clipPath id='clip0_51519_113917'>
                <rect width='16' height='16' fill='white' transform='translate(0.666016)' />
            </clipPath>
        </defs>
    </svg>;
};

export default IconLimits;
